import React from 'react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from '../ui/dialog';
import { Card } from '../ui/card';
import { Badge } from '../ui/badge';
import { Code, Brain, TrendingUp, Database, Wrench, Users } from 'lucide-react';
import { ScrollArea } from '../ui/scroll-area';

const SkillsModal = ({ isOpen, onClose, skills }) => {
  const skillCategories = [
    { title: 'Programming', icon: <Code size={24} />, skills: skills.programming, color: 'blue' },
    { title: 'AI & Tools', icon: <Brain size={24} />, skills: skills.aiTools, color: 'purple' },
    { title: 'Finance', icon: <TrendingUp size={24} />, skills: skills.finance, color: 'green' },
    { title: 'Data Analysis', icon: <Database size={24} />, skills: skills.dataAnalysis, color: 'cyan' },
    { title: 'Tools & Platforms', icon: <Wrench size={24} />, skills: skills.tools, color: 'orange' },
    { title: 'Soft Skills', icon: <Users size={24} />, skills: skills.softSkills, color: 'pink' }
  ];

  const colorClasses = {
    blue: 'text-blue-500 bg-blue-950 border-blue-800',
    purple: 'text-purple-500 bg-purple-950 border-purple-800',
    green: 'text-green-500 bg-green-950 border-green-800',
    cyan: 'text-cyan-500 bg-cyan-950 border-cyan-800',
    orange: 'text-orange-500 bg-orange-950 border-orange-800',
    pink: 'text-pink-500 bg-pink-950 border-pink-800'
  };

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="bg-slate-950 border-slate-800 text-white max-w-5xl max-h-[80vh]">
        <DialogHeader>
          <DialogTitle className="text-3xl font-bold">Skills & Expertise</DialogTitle>
          <DialogDescription className="text-slate-400">
            A diverse skill set spanning technology and finance
          </DialogDescription>
        </DialogHeader>
        
        <ScrollArea className="h-[60vh] pr-4">
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {skillCategories.map((category, index) => (
              <Card key={index} className="bg-slate-900 border-slate-800 p-6">
                <div className="flex items-center gap-3 mb-4">
                  <div className={`${colorClasses[category.color].split(' ')[0]}`}>
                    {category.icon}
                  </div>
                  <h3 className="text-xl font-bold text-white">{category.title}</h3>
                </div>
                
                <div className="flex flex-wrap gap-2">
                  {category.skills.map((skill, idx) => (
                    <Badge 
                      key={idx} 
                      variant="secondary" 
                      className={colorClasses[category.color]}
                    >
                      {skill}
                    </Badge>
                  ))}
                </div>
              </Card>
            ))}
          </div>
        </ScrollArea>
      </DialogContent>
    </Dialog>
  );
};

export default SkillsModal;
